export default function Facturacion() {
  return (
    <section className="facturacion">
      <div className="container">
        <div className="section-header">
          <p className="section-overline">Información administrativa</p>
          <h2 className="section-title dark">Facturación y Crédito</h2>
          <div className="section-divider" />
        </div>

        <div className="fact-single">
          <div className="fact-single-left">
            <div className="fact-icon">🧾</div>
            <h3 className="fact-title">Facturación y Crédito y Cobranza</h3>
            <p style={{ fontSize: '14px', color: 'var(--text-muted)', lineHeight: '1.7', marginTop: '-12px', marginBottom: '28px' }}>
              Para cualquier trámite de factura, crédito o cobranza comunícate directamente con nosotros.
            </p>
          </div>

          <div className="fact-single-right">
            <div className="fact-item">
              <span className="fact-label">Teléfono</span>
              <span className="fact-value">378 145 5022</span>
            </div>
            <div className="fact-item">
              <span className="fact-label">Correo</span>
              <a href="mailto:aceroseconomicosdetepa@gmail.com" className="fact-value fact-link">
                aceroseconomicosdetepa@gmail.com
              </a>
            </div>
            <div className="fact-item">
              <span className="fact-label">Dirección</span>
              <span className="fact-value">Bertha Gutiérrez Padilla #1650, Cuatro Caminos, C.P. 47656, Tepatitlán de Morelos, Jal.</span>
            </div>
            <div className="fact-item">
              <span className="fact-label">Horario</span>
              <span className="fact-value">Lun – Vie 8:30–17:00 &nbsp;|&nbsp; Sáb 8:30–14:00</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
